<template>
  <div class="AllComics">
    <div v-if="selectedComic == 'GameComic'">
      <Comics></Comics>
    </div>
    <div  v-else-if="selectedComic == 'LaisseMoiSortir'">
      <LaisseMoiSortir></LaisseMoiSortir>
    </div>
    <div v-else-if="selectedComic == 'leDelit'">
      <leDelit></leDelit>
    </div>

  </div>
</template>

<script>
import Comics from './Comics'
import LaisseMoiSortir from './LaisseMoiSortir'
import leDelit from './leDelit'

export default {
  name: 'AllComics',
  props:['selectedComic'],
  test: '',
  data: () =>({
    myselection : this.selectedComic
  }),
  components:{
      'Comics': Comics,
      'LaisseMoiSortir': LaisseMoiSortir,
      'leDelit': leDelit

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title{
    text-align:center;
    }


</style>
